// @ts-expect-error TS(7031): Binding element 'data' implicitly has an 'any' typ... Remove this comment to see the full error message
export default function postMessage({ data, origin }) {
  if (!window?.opener || !data || !origin) return;
  window.opener.postMessage(data, origin);
}
